import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const markdownComponents = {
  h1: ({ children }) => <h1 className="text-2xl font-bold text-gray-900 dark:text-white mt-6 mb-3 first:mt-0">{children}</h1>,
  h2: ({ children }) => <h2 className="text-xl font-semibold text-gray-900 dark:text-white mt-5 mb-2">{children}</h2>,
  h3: ({ children }) => <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mt-4 mb-2">{children}</h3>,
  h4: ({ children }) => <h4 className="text-base font-semibold text-gray-800 dark:text-gray-200 mt-3 mb-1">{children}</h4>,
  p: ({ children }) => <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-3 last:mb-0">{children}</p>,
  ul: ({ children }) => <ul className="list-disc list-inside space-y-1.5 mb-3 ml-2 text-gray-700 dark:text-gray-300">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal list-inside space-y-1.5 mb-3 ml-2 text-gray-700 dark:text-gray-300">{children}</ol>,
  li: ({ children }) => <li className="leading-relaxed">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold text-gray-900 dark:text-white">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  blockquote: ({ children }) => <blockquote className="border-l-4 border-blue-400 dark:border-blue-500 pl-4 py-1 my-3 bg-blue-50 dark:bg-blue-900/20 rounded-r-md text-gray-700 dark:text-gray-300">{children}</blockquote>,
  code: ({ children }) => <strong className="font-semibold text-gray-900 dark:text-white">{children}</strong>,
  pre: ({ children }) => <pre className="bg-gray-100 dark:bg-gray-700 text-sm p-3 rounded-md font-mono text-gray-800 dark:text-gray-200 overflow-x-auto mb-3">{children}</pre>,
  a: ({ href, children }) => <a href={href} className="text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300" target="_blank" rel="noopener noreferrer">{children}</a>,
  hr: () => <hr className="border-gray-200 dark:border-gray-600 my-4" />,
  table: ({ children }) => <div className="overflow-x-auto mb-3"><table className="min-w-full border border-gray-200 dark:border-gray-600 rounded-md text-sm">{children}</table></div>,
  thead: ({ children }) => <thead className="bg-gray-50 dark:bg-gray-700">{children}</thead>,
  th: ({ children }) => <th className="px-3 py-2 text-left font-semibold text-gray-900 dark:text-white border-b border-gray-200 dark:border-gray-600">{children}</th>,
  td: ({ children }) => <td className="px-3 py-2 text-gray-700 dark:text-gray-300 border-b border-gray-100 dark:border-gray-700">{children}</td>,
};

const PresaleIdeas = ({ presaleIdeas }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!presaleIdeas || presaleIdeas.trim() === '') {
    return null;
  }

  return (
    <div className="m-6 p-0">
      <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 dark:bg-gray-800 border-t-4 border-t-blue-600">
        <div
          className="flex items-center gap-3 pb-4 border-b border-gray-200 dark:border-gray-600 cursor-pointer select-none"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <div className="w-10 h-10 rounded-lg flex items-center justify-center text-xl font-bold text-white bg-blue-600 shrink-0">💡</div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white m-0 flex-1">Presale Ideas</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            className={`w-5 h-5 text-gray-500 dark:text-gray-400 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`}
          >
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
          </svg>
        </div>
        {isExpanded && (
          <div className="mt-5">
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
              {presaleIdeas}
            </ReactMarkdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default PresaleIdeas;
